import { getParams } from 'app/playbook-editor/get-params';

// Deprecated `vars` still comes from the saved base revision row (it has no
// live editing surface). Pipeline-variable declarations mirror the save path
// (revision-header handleSaveWithCommitMessage) but read the LIVE editor
// params, so an unsaved pipeline-variable toggle is respected by the test.
export default function buildEditorRevisionMeta({ integration, playbookState }) {
  const revision = (integration.playbooks ?? []).find(playbook => playbook.id === playbookState.baseRevisionId) ?? null;
  // connectionJSON is null until the editor loads a revision (playbook-state initial state).
  const params = getParams(playbookState.connectionJSON ?? {}, playbookState.playbook);

  return {
    vars: revision?.vars ?? null,
    pipelineVariables: params.filter(param => param.pipelineVarId).map(param => ({ name: param.name })),
  };
}
